import { useMemo } from "react";

import { Medication } from "@types-runway/condition";
import { hasTimeForLabExam, medicationRequiresLabExam } from "@utils/labExam/labExam";

const useAvailableMedications = (
  medications: Medication[],
  departureDate: string | undefined
): Medication[] => {
  return useMemo(() => {
    if (!departureDate || hasTimeForLabExam(departureDate)) {
      return medications;
    }
    return medications.filter((med) => !medicationRequiresLabExam(med));
  }, [medications, departureDate]);
};

export default useAvailableMedications;
